import { render, staticRenderFns } from "./DailyInvestDetails.vue?vue&type=template&id=3fa1c98c&scoped=true&"
import script from "./DailyInvestDetails.vue?vue&type=script&lang=js&"
export * from "./DailyInvestDetails.vue?vue&type=script&lang=js&"
import style0 from "./DailyInvestDetails.vue?vue&type=style&index=0&id=3fa1c98c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa1c98c",
  null
  
)

export default component.exports